/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';


import { AccessTokenError } from '../model/accessTokenError';
import { AddAccessCreateRequestInfo } from '../model/addAccessCreateRequestInfo';
import { AddAccessCreateResponseInfo } from '../model/addAccessCreateResponseInfo';
import { DeptSelectorResponse } from '../model/deptSelectorResponse';
import { DeptSelectorResponse2 } from '../model/deptSelectorResponse2';
import { ErrorMessage } from '../model/errorMessage';
import { ForgotPasswordRequest } from '../model/forgotPasswordRequest';
import { ForgotPasswordResponse } from '../model/forgotPasswordResponse';
import { GroupSelectorResponse } from '../model/groupSelectorResponse';
import { InlineResponse2005 } from '../model/inlineResponse2005';
import { LaunchRequestInfo } from '../model/launchRequestInfo';
import { LaunchResponseInfo } from '../model/launchResponseInfo';
import { LoginAttemptRequestInfo } from '../model/loginAttemptRequestInfo';
import { LoginAttemptResponseInfo } from '../model/loginAttemptResponseInfo';
import { OrgResponseInfoList3 } from '../model/orgResponseInfoList3';
import { OrgRolePermissionResponseInfo } from '../model/orgRolePermissionResponseInfo';
import { OrgSelectorResponse } from '../model/orgSelectorResponse';
import { PasswordChangeRequest } from '../model/passwordChangeRequest';
import { PasswordChangeResponse } from '../model/passwordChangeResponse';
import { PasswordResetRetrieve } from '../model/passwordResetRetrieve';
import { Request3 } from '../model/request3';
import { Request4 } from '../model/request4';
import { ResetPasswordRequest } from '../model/resetPasswordRequest';
import { ResetPasswordResponse } from '../model/resetPasswordResponse';
import { ResponseList } from '../model/responseList';
import { UserAuthRequestInfo } from '../model/userAuthRequestInfo';
import { UserAuthResponseInfo } from '../model/userAuthResponseInfo';
import { UserCreateRequestInfo } from '../model/userCreateRequestInfo';
import { UserCreateResponseInfo } from '../model/userCreateResponseInfo';
import { UserGroupRoleCreateRequestInfo } from '../model/userGroupRoleCreateRequestInfo';
import { UserGroupRoleCreateResponseInfo } from '../model/userGroupRoleCreateResponseInfo';
import { UserPasswordResetTokenVerificationRequest } from '../model/userPasswordResetTokenVerificationRequest';
import { UserPasswordResetTokenVerificationResponse } from '../model/userPasswordResetTokenVerificationResponse';
import { UserRetrieveResponseInfo } from '../model/userRetrieveResponseInfo';
import { UserRoleRemoveAccessRequestInfo } from '../model/userRoleRemoveAccessRequestInfo';
import { UserRoleRemoveAccessResponseInfo } from '../model/userRoleRemoveAccessResponseInfo';
import { UserSearchRequestInfo } from '../model/userSearchRequestInfo';
import { UserSearchRequestInfo2 } from '../model/userSearchRequestInfo2';
import { UserSearchResponseInfo } from '../model/userSearchResponseInfo';
import { UserSearchResponseInfo2 } from '../model/userSearchResponseInfo2';
import { UserSnapshotRequest } from '../model/userSnapshotRequest';
import { UserSnapshotResponse } from '../model/userSnapshotResponse';
import { UserTokenInfoResponseInfo } from '../model/userTokenInfoResponseInfo';
import { UserTokenRequestInfo } from '../model/userTokenRequestInfo';
import { UserTokenResponseInfo } from '../model/userTokenResponseInfo';
import { UserUpdateRequestInfo } from '../model/userUpdateRequestInfo';
import { UserUpdateResponseInfo } from '../model/userUpdateResponseInfo';
import { WebAuthenticationLaunchRequest } from '../model/webAuthenticationLaunchRequest';
import { WebAuthenticationLaunchResponse } from '../model/webAuthenticationLaunchResponse';
import { WebTokenAuthenticateRequest } from '../model/webTokenAuthenticateRequest';
import { WebTokenAuthenticateResponse } from '../model/webTokenAuthenticateResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { Observable } from 'rxjs';


@Injectable()
export class UserMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * OrgMgr_AuthDelete, Delete a auth
     * This Service will Delete a auth
     * @param Id Enter the Id tend to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrUserMgrV1AuthIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrUserMgrV1AuthIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrUserMgrV1AuthIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrUserMgrV1AuthIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/UserMgr/V1/Auth/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_AuthRetrieve, Retrieve a auth
     * This Service will Retrieve a auth
     * @param Id Enter the Id tend to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2005>;
    public orgMgrUserMgrV1AuthIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrUserMgrV1AuthIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<InlineResponse2005>(`${this.basePath}/OrgMgr/UserMgr/V1/Auth/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_AuthUpdate, Update a auth
     * This Service will Update a auth
     * @param Id Enter the Id tend to update
     * @param Request Enter the Credentials
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthIdPut(Id: number, Request: Request4, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2005>;
    public orgMgrUserMgrV1AuthIdPut(Id: number, Request: Request4, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthIdPut(Id: number, Request: Request4, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthIdPut(Id: number, Request: Request4, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrUserMgrV1AuthIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1AuthIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<InlineResponse2005>(`${this.basePath}/OrgMgr/UserMgr/V1/Auth/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_AuthCreate, Create a auth
     * This Service will create a auth
     * @param Request Enter the Credentials
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthPost(Request: Request3, observe?: 'body', reportProgress?: boolean): Observable<InlineResponse2005>;
    public orgMgrUserMgrV1AuthPost(Request: Request3, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthPost(Request: Request3, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InlineResponse2005>>;
    public orgMgrUserMgrV1AuthPost(Request: Request3, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1AuthPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<InlineResponse2005>(`${this.basePath}/OrgMgr/UserMgr/V1/Auth`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_Authenticate, Checks user authenticated
     * Checks user authenticated by passing the credentials
     * @param AppName Enter the AppName
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthenticatePost(AppName: string, GroupId: number, Request: UserAuthRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<UserAuthResponseInfo>;
    public orgMgrUserMgrV1AuthenticatePost(AppName: string, GroupId: number, Request: UserAuthRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserAuthResponseInfo>>;
    public orgMgrUserMgrV1AuthenticatePost(AppName: string, GroupId: number, Request: UserAuthRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserAuthResponseInfo>>;
    public orgMgrUserMgrV1AuthenticatePost(AppName: string, GroupId: number, Request: UserAuthRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrUserMgrV1AuthenticatePost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1AuthenticatePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1AuthenticatePost.');
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserAuthResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/Authenticate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_Authorize, Checks user Authorized
     * Checks user Authorized and return back accessToken details with
     * @param ApiName Enter the ApiName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1AuthorizeGet(ApiName: string, observe?: 'body', reportProgress?: boolean): Observable<UserTokenInfoResponseInfo>;
    public orgMgrUserMgrV1AuthorizeGet(ApiName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserTokenInfoResponseInfo>>;
    public orgMgrUserMgrV1AuthorizeGet(ApiName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserTokenInfoResponseInfo>>;
    public orgMgrUserMgrV1AuthorizeGet(ApiName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ApiName === null || ApiName === undefined) {
            throw new Error('Required parameter ApiName was null or undefined when calling orgMgrUserMgrV1AuthorizeGet.');
        }

        let headers = this.defaultHeaders;
        if (ApiName !== undefined && ApiName !== null) {
            headers = headers.set('ApiName', String(ApiName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<UserTokenInfoResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/Authorize`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_DeptSelector, Retrieve the Depts
     * Retrieve the Depts
     * @param OrgId Enter the OrgId
     * @param FacilityId Enter the FacilityId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1DeptSelectorGet(OrgId: number, FacilityId: number, observe?: 'body', reportProgress?: boolean): Observable<DeptSelectorResponse>;
    public orgMgrUserMgrV1DeptSelectorGet(OrgId: number, FacilityId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeptSelectorResponse>>;
    public orgMgrUserMgrV1DeptSelectorGet(OrgId: number, FacilityId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeptSelectorResponse>>;
    public orgMgrUserMgrV1DeptSelectorGet(OrgId: number, FacilityId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrUserMgrV1DeptSelectorGet.');
        }
        if (FacilityId === null || FacilityId === undefined) {
            throw new Error('Required parameter FacilityId was null or undefined when calling orgMgrUserMgrV1DeptSelectorGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (FacilityId !== undefined && FacilityId !== null) {
            headers = headers.set('FacilityId', String(FacilityId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DeptSelectorResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/Dept/Selector`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_FacilitySelector, Retrieve the Facilities by OrgId and GroupId
     * Retrieve the Facilitys
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1FacilitySelectorGet(GroupId: number, OrgId?: number, observe?: 'body', reportProgress?: boolean): Observable<DeptSelectorResponse2>;
    public orgMgrUserMgrV1FacilitySelectorGet(GroupId: number, OrgId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DeptSelectorResponse2>>;
    public orgMgrUserMgrV1FacilitySelectorGet(GroupId: number, OrgId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DeptSelectorResponse2>>;
    public orgMgrUserMgrV1FacilitySelectorGet(GroupId: number, OrgId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1FacilitySelectorGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DeptSelectorResponse2>(`${this.basePath}/OrgMgr/UserMgr/V1/Facility/Selector`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_GroupSelector, Retrieve the Groups as per UserType
     * Retrieve the Groups as per UserType
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1GroupSelectorGet(observe?: 'body', reportProgress?: boolean): Observable<GroupSelectorResponse>;
    public orgMgrUserMgrV1GroupSelectorGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GroupSelectorResponse>>;
    public orgMgrUserMgrV1GroupSelectorGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GroupSelectorResponse>>;
    public orgMgrUserMgrV1GroupSelectorGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GroupSelectorResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/Group/Selector`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_LoginAttempt, Search to find  the LoginAttempt done by the User
     * Search to find  the LoginAttempt done by the User
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1LoginAttemptPost(Request: LoginAttemptRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<LoginAttemptResponseInfo>;
    public orgMgrUserMgrV1LoginAttemptPost(Request: LoginAttemptRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoginAttemptResponseInfo>>;
    public orgMgrUserMgrV1LoginAttemptPost(Request: LoginAttemptRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoginAttemptResponseInfo>>;
    public orgMgrUserMgrV1LoginAttemptPost(Request: LoginAttemptRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1LoginAttemptPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<LoginAttemptResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/LoginAttempt`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_Org, Get the Org based on UserId and GroupId
     * Get the Org based based on UserId and GroupId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1OrgGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<OrgResponseInfoList3>;
    public orgMgrUserMgrV1OrgGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrgResponseInfoList3>>;
    public orgMgrUserMgrV1OrgGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrgResponseInfoList3>>;
    public orgMgrUserMgrV1OrgGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1OrgGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<OrgResponseInfoList3>(`${this.basePath}/OrgMgr/UserMgr/V1/Org`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_OrgProfile, Get the Org profile based on UserId and GroupId
     * Get the Org profile based on UserId and GroupId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1OrgProfileGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseList>;
    public orgMgrUserMgrV1OrgProfileGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseList>>;
    public orgMgrUserMgrV1OrgProfileGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseList>>;
    public orgMgrUserMgrV1OrgProfileGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1OrgProfileGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ResponseList>(`${this.basePath}/OrgMgr/UserMgr/V1/Org/Profile`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_GroupHierarchy, Retrieve the Group Hierarchy based on UserId
     * Retrieve the Group Hierarchy based on UserId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1OrgSelectorGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<OrgSelectorResponse>;
    public orgMgrUserMgrV1OrgSelectorGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrgSelectorResponse>>;
    public orgMgrUserMgrV1OrgSelectorGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrgSelectorResponse>>;
    public orgMgrUserMgrV1OrgSelectorGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1OrgSelectorGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<OrgSelectorResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/Org/Selector`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_Permission, Get the Org based Role Permission
     * Get the Org based Role Permission
     * @param OrgId Enter the OrgId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1PermissionGet(OrgId: number, observe?: 'body', reportProgress?: boolean): Observable<OrgRolePermissionResponseInfo>;
    public orgMgrUserMgrV1PermissionGet(OrgId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OrgRolePermissionResponseInfo>>;
    public orgMgrUserMgrV1PermissionGet(OrgId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OrgRolePermissionResponseInfo>>;
    public orgMgrUserMgrV1PermissionGet(OrgId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrUserMgrV1PermissionGet.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<OrgRolePermissionResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/Permission`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_TokenLogout, Token Logout
     * Token Logout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1TokenLogoutGet(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrUserMgrV1TokenLogoutGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrUserMgrV1TokenLogoutGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrUserMgrV1TokenLogoutGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/OrgMgr/UserMgr/V1/Token/Logout`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_TokenRefresh, Token Refresh
     * Token Refresh
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1TokenRefreshPost(Request: UserTokenRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<UserTokenResponseInfo>;
    public orgMgrUserMgrV1TokenRefreshPost(Request: UserTokenRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserTokenResponseInfo>>;
    public orgMgrUserMgrV1TokenRefreshPost(Request: UserTokenRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserTokenResponseInfo>>;
    public orgMgrUserMgrV1TokenRefreshPost(Request: UserTokenRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1TokenRefreshPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserTokenResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/Token/Refresh`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_AddAccessUser, Add Access to User
     * Add Access to User for given Org and RoleId
     * @param GroupId Enter the GroupId
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserAddAccessPost(GroupId: number, OrgId: number, Request: AddAccessCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<AddAccessCreateResponseInfo>;
    public orgMgrUserMgrV1UserAddAccessPost(GroupId: number, OrgId: number, Request: AddAccessCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AddAccessCreateResponseInfo>>;
    public orgMgrUserMgrV1UserAddAccessPost(GroupId: number, OrgId: number, Request: AddAccessCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AddAccessCreateResponseInfo>>;
    public orgMgrUserMgrV1UserAddAccessPost(GroupId: number, OrgId: number, Request: AddAccessCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserAddAccessPost.');
        }
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling orgMgrUserMgrV1UserAddAccessPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserAddAccessPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<AddAccessCreateResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/User/AddAccess`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_ChangePassword, Password will be changed
     * Password will be changed
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserChangePasswordPost(Request: PasswordChangeRequest, observe?: 'body', reportProgress?: boolean): Observable<PasswordChangeResponse>;
    public orgMgrUserMgrV1UserChangePasswordPost(Request: PasswordChangeRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PasswordChangeResponse>>;
    public orgMgrUserMgrV1UserChangePasswordPost(Request: PasswordChangeRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PasswordChangeResponse>>;
    public orgMgrUserMgrV1UserChangePasswordPost(Request: PasswordChangeRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserChangePasswordPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PasswordChangeResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/User/ChangePassword`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_ForgotPassword, Sends a email to reset the forgot password
     * Sends a email to reset the forgot password
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserForgotPasswordPost(Request: ForgotPasswordRequest, observe?: 'body', reportProgress?: boolean): Observable<ForgotPasswordResponse>;
    public orgMgrUserMgrV1UserForgotPasswordPost(Request: ForgotPasswordRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ForgotPasswordResponse>>;
    public orgMgrUserMgrV1UserForgotPasswordPost(Request: ForgotPasswordRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ForgotPasswordResponse>>;
    public orgMgrUserMgrV1UserForgotPasswordPost(Request: ForgotPasswordRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserForgotPasswordPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ForgotPasswordResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/User/ForgotPassword`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_RetrieveUser, Retrieve a User by passing UserId
     * Retrieve a User by passing UserId
     * @param UserId Enter the UserId that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserGet(UserId: number, observe?: 'body', reportProgress?: boolean): Observable<UserRetrieveResponseInfo>;
    public orgMgrUserMgrV1UserGet(UserId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserRetrieveResponseInfo>>;
    public orgMgrUserMgrV1UserGet(UserId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserRetrieveResponseInfo>>;
    public orgMgrUserMgrV1UserGet(UserId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserGet.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<UserRetrieveResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/User`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_UpdateUser, Update a User
     * Update a User
     * @param UserId Enter the UserId that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserPatch(UserId: number, Request: UserUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<UserUpdateResponseInfo>;
    public orgMgrUserMgrV1UserPatch(UserId: number, Request: UserUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserUpdateResponseInfo>>;
    public orgMgrUserMgrV1UserPatch(UserId: number, Request: UserUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserUpdateResponseInfo>>;
    public orgMgrUserMgrV1UserPatch(UserId: number, Request: UserUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserPatch.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<UserUpdateResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/User`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_CreateUser, Create a User
     * Create a User
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param AppName Enter the AppName, default is ClientAdmin (2)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserPost(GroupId: number, Request: UserCreateRequestInfo, AppName?: string, observe?: 'body', reportProgress?: boolean): Observable<UserCreateResponseInfo>;
    public orgMgrUserMgrV1UserPost(GroupId: number, Request: UserCreateRequestInfo, AppName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserCreateResponseInfo>>;
    public orgMgrUserMgrV1UserPost(GroupId: number, Request: UserCreateRequestInfo, AppName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserCreateResponseInfo>>;
    public orgMgrUserMgrV1UserPost(GroupId: number, Request: UserCreateRequestInfo, AppName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserPost.');
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserCreateResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/User`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_RetrievePasswordReset, Retrieve PasswordReset details
     * Retrieve PasswordReset details
     * @param Id Enter the PasswordReset Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserResetPasswordIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<PasswordResetRetrieve>;
    public orgMgrUserMgrV1UserResetPasswordIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PasswordResetRetrieve>>;
    public orgMgrUserMgrV1UserResetPasswordIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PasswordResetRetrieve>>;
    public orgMgrUserMgrV1UserResetPasswordIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling orgMgrUserMgrV1UserResetPasswordIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PasswordResetRetrieve>(`${this.basePath}/OrgMgr/UserMgr/V1/User/ResetPassword/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_ResetPassword, Reset Password
     * Reset the password
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserResetPasswordPost(Request: ResetPasswordRequest, observe?: 'body', reportProgress?: boolean): Observable<ResetPasswordResponse>;
    public orgMgrUserMgrV1UserResetPasswordPost(Request: ResetPasswordRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResetPasswordResponse>>;
    public orgMgrUserMgrV1UserResetPasswordPost(Request: ResetPasswordRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResetPasswordResponse>>;
    public orgMgrUserMgrV1UserResetPasswordPost(Request: ResetPasswordRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserResetPasswordPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ResetPasswordResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/User/ResetPassword`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_PasswordResetTokenVerification, Password ResetToken Verification
     * Verification of Password ResetToken
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserResetPasswordTokenVerificationPost(Request: UserPasswordResetTokenVerificationRequest, observe?: 'body', reportProgress?: boolean): Observable<UserPasswordResetTokenVerificationResponse>;
    public orgMgrUserMgrV1UserResetPasswordTokenVerificationPost(Request: UserPasswordResetTokenVerificationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserPasswordResetTokenVerificationResponse>>;
    public orgMgrUserMgrV1UserResetPasswordTokenVerificationPost(Request: UserPasswordResetTokenVerificationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserPasswordResetTokenVerificationResponse>>;
    public orgMgrUserMgrV1UserResetPasswordTokenVerificationPost(Request: UserPasswordResetTokenVerificationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserResetPasswordTokenVerificationPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserPasswordResetTokenVerificationResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/User/ResetPassword/Token/Verification`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_RetrieveUserRole, Retrieve the UserRoles for given User
     * Retrieve the UserRoles for given User
     * @param GroupId Enter the GroupId
     * @param UserId Enter the UserId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserRoleGet(GroupId: number, UserId: number, observe?: 'body', reportProgress?: boolean): Observable<UserGroupRoleCreateResponseInfo>;
    public orgMgrUserMgrV1UserRoleGet(GroupId: number, UserId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGroupRoleCreateResponseInfo>>;
    public orgMgrUserMgrV1UserRoleGet(GroupId: number, UserId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGroupRoleCreateResponseInfo>>;
    public orgMgrUserMgrV1UserRoleGet(GroupId: number, UserId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserRoleGet.');
        }
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserRoleGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<UserGroupRoleCreateResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/UserRole`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_AssignUserRole, Create/Update/Delete a UserRole
     * Create/Update/Delete a UserRole
     * @param UserId Enter the UserId
     * @param GroupId Enter the Super parent GroupId
     * @param Request Enter the request values
     * @param AppId Enter the AppId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserRolePut(UserId: number, GroupId: number, Request: UserGroupRoleCreateRequestInfo, AppId?: number, observe?: 'body', reportProgress?: boolean): Observable<UserGroupRoleCreateResponseInfo>;
    public orgMgrUserMgrV1UserRolePut(UserId: number, GroupId: number, Request: UserGroupRoleCreateRequestInfo, AppId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserGroupRoleCreateResponseInfo>>;
    public orgMgrUserMgrV1UserRolePut(UserId: number, GroupId: number, Request: UserGroupRoleCreateRequestInfo, AppId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserGroupRoleCreateResponseInfo>>;
    public orgMgrUserMgrV1UserRolePut(UserId: number, GroupId: number, Request: UserGroupRoleCreateRequestInfo, AppId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserRolePut.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserRolePut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserRolePut.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppId !== undefined && AppId !== null) {
            headers = headers.set('AppId', String(AppId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<UserGroupRoleCreateResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/UserRole`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_UserRoleRemoveAccess, RemoveAccess to UserRole
     * RemoveAccess to UserRole by updating given OrgId to NoAccess or create a new record for given OrgId with NoAccess Role
     * @param UserId Enter the UserId
     * @param GroupId Enter the Super parent GroupId
     * @param Request Enter the request values
     * @param AppId Enter the AppName
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserRoleRemoveAccessPut(UserId: number, GroupId: number, Request: UserRoleRemoveAccessRequestInfo, AppId?: string, observe?: 'body', reportProgress?: boolean): Observable<UserRoleRemoveAccessResponseInfo>;
    public orgMgrUserMgrV1UserRoleRemoveAccessPut(UserId: number, GroupId: number, Request: UserRoleRemoveAccessRequestInfo, AppId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserRoleRemoveAccessResponseInfo>>;
    public orgMgrUserMgrV1UserRoleRemoveAccessPut(UserId: number, GroupId: number, Request: UserRoleRemoveAccessRequestInfo, AppId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserRoleRemoveAccessResponseInfo>>;
    public orgMgrUserMgrV1UserRoleRemoveAccessPut(UserId: number, GroupId: number, Request: UserRoleRemoveAccessRequestInfo, AppId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserRoleRemoveAccessPut.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserRoleRemoveAccessPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserRoleRemoveAccessPut.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (AppId !== undefined && AppId !== null) {
            headers = headers.set('AppId', String(AppId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<UserRoleRemoveAccessResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/UserRole/RemoveAccess`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_SearchUser, Search a User based on FirstName or LastName or Email
     * Search a User based on FirstName or LastName or Email
     * @param GroupId Enter  GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserSearchPost(GroupId: number, Request: UserSearchRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<UserSearchResponseInfo>;
    public orgMgrUserMgrV1UserSearchPost(GroupId: number, Request: UserSearchRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSearchResponseInfo>>;
    public orgMgrUserMgrV1UserSearchPost(GroupId: number, Request: UserSearchRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSearchResponseInfo>>;
    public orgMgrUserMgrV1UserSearchPost(GroupId: number, Request: UserSearchRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserSearchPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserSearchPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserSearchResponseInfo>(`${this.basePath}/OrgMgr/UserMgr/V1/User/Search`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_Snapshot, Get User snapshot based on UserId and GroupId
     * Checks user Authorized and return back accessToken details with
     * @param UserId UserId to retrieve the snapshot
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserSnapshotPost(UserId: number, Request: UserSnapshotRequest, observe?: 'body', reportProgress?: boolean): Observable<UserSnapshotResponse>;
    public orgMgrUserMgrV1UserSnapshotPost(UserId: number, Request: UserSnapshotRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSnapshotResponse>>;
    public orgMgrUserMgrV1UserSnapshotPost(UserId: number, Request: UserSnapshotRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSnapshotResponse>>;
    public orgMgrUserMgrV1UserSnapshotPost(UserId: number, Request: UserSnapshotRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrUserMgrV1UserSnapshotPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserSnapshotPost.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserSnapshotResponse>(`${this.basePath}/OrgMgr/UserMgr/V1/User/Snapshot`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_UserMgr_CheckUsername, Check whether user exits for given username
     * Check whether user exits for given username
     * @param GroupId Enter  GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrUserMgrV1UserUsernamePost(GroupId: number, Request: UserSearchRequestInfo2, observe?: 'body', reportProgress?: boolean): Observable<UserSearchResponseInfo2>;
    public orgMgrUserMgrV1UserUsernamePost(GroupId: number, Request: UserSearchRequestInfo2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserSearchResponseInfo2>>;
    public orgMgrUserMgrV1UserUsernamePost(GroupId: number, Request: UserSearchRequestInfo2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserSearchResponseInfo2>>;
    public orgMgrUserMgrV1UserUsernamePost(GroupId: number, Request: UserSearchRequestInfo2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrUserMgrV1UserUsernamePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrUserMgrV1UserUsernamePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys?.Authorization) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<UserSearchResponseInfo2>(`${this.basePath}/OrgMgr/UserMgr/V1/User/Username`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_Launch, Checks user/consumer is authenticated
     * Checks user/consumer is authenticated by passing the payload
     * @param AppName Enter the AppName
     * @param SiteName Enter the SiteName
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1LaunchPost(AppName: string, SiteName: string, Request: LaunchRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<LaunchResponseInfo>;
    public orgMgrV1LaunchPost(AppName: string, SiteName: string, Request: LaunchRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LaunchResponseInfo>>;
    public orgMgrV1LaunchPost(AppName: string, SiteName: string, Request: LaunchRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LaunchResponseInfo>>;
    public orgMgrV1LaunchPost(AppName: string, SiteName: string, Request: LaunchRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1LaunchPost.');
        }
        if (SiteName === null || SiteName === undefined) {
            throw new Error('Required parameter SiteName was null or undefined when calling orgMgrV1LaunchPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrV1LaunchPost.');
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }
        if (SiteName !== undefined && SiteName !== null) {
            headers = headers.set('SiteName', String(SiteName));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<LaunchResponseInfo>(`${this.basePath}/OrgMgr/V1/Launch`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_WebAuthenticationLaunch, Create WebTokenLink for JWTSSO
     * Create WebTokenLink for JWTSSO
     * @param AppName Enter the AppName
     * @param ConnectionId Enter the ConnectionId
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebAuthenticationLaunchPost(AppName: string, ConnectionId: string, request: WebAuthenticationLaunchRequest, observe?: 'body', reportProgress?: boolean): Observable<WebAuthenticationLaunchResponse>;
    public orgMgrV1WebAuthenticationLaunchPost(AppName: string, ConnectionId: string, request: WebAuthenticationLaunchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebAuthenticationLaunchResponse>>;
    public orgMgrV1WebAuthenticationLaunchPost(AppName: string, ConnectionId: string, request: WebAuthenticationLaunchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebAuthenticationLaunchResponse>>;
    public orgMgrV1WebAuthenticationLaunchPost(AppName: string, ConnectionId: string, request: WebAuthenticationLaunchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (AppName === null || AppName === undefined) {
            throw new Error('Required parameter AppName was null or undefined when calling orgMgrV1WebAuthenticationLaunchPost.');
        }
        if (ConnectionId === null || ConnectionId === undefined) {
            throw new Error('Required parameter ConnectionId was null or undefined when calling orgMgrV1WebAuthenticationLaunchPost.');
        }
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1WebAuthenticationLaunchPost.');
        }

        let headers = this.defaultHeaders;
        if (AppName !== undefined && AppName !== null) {
            headers = headers.set('AppName', String(AppName));
        }
        if (ConnectionId !== undefined && ConnectionId !== null) {
            headers = headers.set('ConnectionId', String(ConnectionId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<WebAuthenticationLaunchResponse>(`${this.basePath}/OrgMgr/V1/WebAuthentication/Launch`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_WebTokenAuthenticate, Check WebToken Authentication
     * Check WebToken Authentication
     * @param request Enter the request
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrV1WebTokenAuthenticatePost(request: WebTokenAuthenticateRequest, observe?: 'body', reportProgress?: boolean): Observable<WebTokenAuthenticateResponse>;
    public orgMgrV1WebTokenAuthenticatePost(request: WebTokenAuthenticateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<WebTokenAuthenticateResponse>>;
    public orgMgrV1WebTokenAuthenticatePost(request: WebTokenAuthenticateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<WebTokenAuthenticateResponse>>;
    public orgMgrV1WebTokenAuthenticatePost(request: WebTokenAuthenticateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling orgMgrV1WebTokenAuthenticatePost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<WebTokenAuthenticateResponse>(`${this.basePath}/OrgMgr/V1/WebToken/Authenticate`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
